import { render, staticRenderFns } from "./PersonalBankDataTab.vue?vue&type=template&id=3ec8a89c"
import script from "./PersonalBankDataTab.vue?vue&type=script&lang=ts"
export * from "./PersonalBankDataTab.vue?vue&type=script&lang=ts"
import style0 from "./PersonalBankDataTab.vue?vue&type=style&index=0&id=3ec8a89c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports